import {clientRestAPI} from '../clientRestAPI/clientRestAPI';
import {getContribuinteHomeAutenticado} from "../routes/auth";

const url = '/historico-resumo-anual';

const historicoResumoAnualModel = {

  state: {
    historicoResumoAnual: {},
    loading: false,
    errors: {},
    redirect: false
  },

  //definindo todos os reducers
  reducers: {

    loading: (state) => {
      return {
        ...state,
        loading: true,
      };
    },

    clearForm: (state) => {
      return {
        ...state,
        historicoResumoAnual: {},
        redirect: false,
        loading: false,
      }
    },

    fetchHistoricoResumoAnualFulfiled: (state, payload) => {
      return {
        ...state,
        historicoResumoAnual: payload.data || payload,
        loading: false,
      };
    },

    error: (state) => {
      return {
        ...state,
        loading: false,
      };
    }
  },


  effects: (dispatch) => ({

    fetchHistoricoResumoAnual(anoReferencia) {

      dispatch.historicoResumoAnualModel.loading();
      const contribuinteAutenticado = getContribuinteHomeAutenticado();

      const newUrl = `${url}/${contribuinteAutenticado.id}/${anoReferencia}`;
      return clientRestAPI.get(newUrl)
        .then(res => {
          dispatch.historicoResumoAnualModel.fetchHistoricoResumoAnualFulfiled(res.data);
        })
        .catch(() => {
          dispatch.historicoResumoAnualModel.error();
        })
    },

    saveHistoricoResumoAnual(historicoResumoAnual) {

      dispatch.historicoResumoAnualModel.loading();

      return clientRestAPI
        .post(url, historicoResumoAnual)
        .then((res) => {
          dispatch.historicoResumoAnualModel.clearForm();
        })
        .catch(() => {
          dispatch.historicoResumoAnualModel.error();
        });
    },

    clearHistoricoResumoAnual() {
      dispatch.historicoResumoAnualModel.clearForm();
    }
  })
};

export default historicoResumoAnualModel;
